module.exports = __webpack_public_path__ + "fonts/Axiforma-SemiBold.30aeae7.ttf";